import { InputOtp } from '@heroui/react';

export function CustomPin({ length, onComplete = () => {}, ...rest }) {
  return (
    <>
      <div className="w-full flex justify-center">
        <InputOtp length={length} onComplete={onComplete} autoFocus variant="faded" {...rest} />
      </div>
    </>
  );
}
